import firebase from 'firebase';

const firebaseConfig = {
    apiKey: 'AIzaSyDHUcVhe7xyshlMgzYdrg9iUC8PzmX_BiA',
    authDomain: 'musical-shepherds.firebaseapp.com',
    databaseURL: 'https://musical-shepherds.firebaseio.com',
    projectId: 'musical-shepherds',
    storageBucket: 'musical-shepherds.appspot.com',
    messagingSenderId: '236360869007',
    appId: '1:236360869007:web:c767d78f4c2fcf55edfcfa',
    measurementId: 'G-K06E20H5TG',
};

export default function useInitFirebase() {
    !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.app();
    firebase.analytics();
}
